import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ColorEnum } from 'shared/design-system/data-access/theme';
import { CustomDialog } from '../../models/custom-dialog/custom-dialog.model';
import { TextComponent } from 'shared/design-system/ui/typography';
import { DialogComponent } from '../dialog/dialog.component';

@Component({
    selector: 'it-confirm-dialog',
    imports: [DialogModule, TextComponent, DialogComponent],
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent implements CustomDialog<void> {
    @Input({ required: true }) inputs!: {
        header: string;
        message: string;
    };
    @Output() accepted = new EventEmitter<void>();
    @Output() cancelled = new EventEmitter<void>();

    ColorEnum = ColorEnum;

    accept = () => {
        this.accepted.emit();
    };

    cancel = () => {
        this.cancelled.emit();
    };
}
